/**
 * Removes a leading `http://` or `https://` scheme from a URL string.
 *
 * Used by the factory website field, which displays `https://` as a visual
 * add-on and stores only the host/path portion in the form model.
 */
export function stripUrlProtocol(url: string): string {
  return url.trim().replace(/^https?:\/\//i, '');
}

/**
 * Serializes a website host/path for the API, prefixing `https://` when non-empty.
 */
export function formatWebsiteForApi(website: string): string {
  const host = stripUrlProtocol(website);
  return host ? `https://${host}` : '';
}
